import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderComponent } from './order.component';
import { Routes, RouterModule } from '@angular/router';
import { UiModule } from '../../ui/ui.module';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { OrderService } from './service/order.service';
import { ProductsComponent } from './products/products.component';
import { BudgetComponent } from './budget/budget.component';
import { BudgetProductComponent } from './budget/budget-product/budget-product.component';
import { ProjectManagementComponent } from './budget/project-management/project-management.component';
import { PickCardComponent } from './budget/project-management/pick-card/pick-card.component';
import { NewProjectComponent } from './budget/project-management/new-project/new-project.component';
import { LinkExistingProjectComponent } from './budget/project-management/link-existing-project/link-existing-project.component';
import { BudgetFillerComponent } from './budget/budget-filler/budget-filler.component';
import { MigrateProjectComponent } from './budget/project-management/migrate-project/migrate-project.component';
import { BudgetSummaryModalComponent } from './budget/budget-summary-modal/budget-summary-modal.component';
import { BudgetConsumptionComponent } from './budget/budget-summary-modal/budget-consumption/budget-consumption.component';
import { ConsumptionChartComponent } from './budget/budget-summary-modal/budget-consumption/consumption-chart/consumption-chart.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { BudgetCreationModalComponent } from './budget/budget-creation-modal/budget-creation-modal.component';
import { UnlinkProjectComponent } from './budget/project-management/unlink-project/unlink-project.component';
import { SendDetailsQuestionModalComponent } from './budget/project-management/new-project/send-details-question-modal/send-details-question-modal.component';
import { ProductAllocationComponent } from './budget/budget-summary-modal/product-allocation/product-allocation.component';
import { ChartComponent } from './budget/budget-summary-modal/product-allocation/chart/chart.component';
import { ProjectCreationSuccessComponent } from './budget/project-management/new-project/project-creation-success/project-creation-success.component';

const routes: Routes = [
  {
    path: '',
    component: OrderComponent,
  },
  {
    path: 'product/:productId',
    component: OrderComponent,
  },
  {
    path: 'budget',
    component: OrderComponent,
  },
  {
    path: 'budget/:budgetId',
    component: OrderComponent,
  },
  {
    path: 'budget/:budgetId/product/:productId',
    component: OrderComponent,
  },
  {
    path: 'product/:productId/budget/:budgetId',
    component: OrderComponent,
  },
];

@NgModule({
  declarations: [
    OrderComponent,
    ProductsComponent,
    BudgetComponent,
    BudgetProductComponent,
    ProjectManagementComponent,
    PickCardComponent,
    NewProjectComponent,
    LinkExistingProjectComponent,
    BudgetFillerComponent,
    MigrateProjectComponent,
    BudgetSummaryModalComponent,
    BudgetConsumptionComponent,
    ConsumptionChartComponent,
    BudgetCreationModalComponent,
    UnlinkProjectComponent,
    SendDetailsQuestionModalComponent,
    ProductAllocationComponent,
    ChartComponent,
    ProjectCreationSuccessComponent
  ],
  imports: [CommonModule, UiModule, NgbModule, NgxChartsModule, RouterModule.forChild(routes), FormsModule],
  providers: [NgbActiveModal, OrderService],
})
export class OrderModule {}
